import Vue from 'vue';
import VueMeta from 'vue-meta';

export default function useMeta () {
  Vue.use(VueMeta);
}

